import { PplDispatchPoint } from '@pages/order/payment-shipping/ppl-script/PplDispatchPoint';
import { DispatchPoint } from '@api/types/DispatchPoint';



export function convertPplToDispatchPoint(pplDispatchPoint: PplDispatchPoint): DispatchPoint | null {
	if ('id' in pplDispatchPoint && 'name' in pplDispatchPoint && 'accessPointType' in pplDispatchPoint && 'code' in pplDispatchPoint) {
		const { id, name, accessPointType, code, street, city, zipCode, country } = pplDispatchPoint;
		return ({
			id: String(id),
			name: name,
			place: `${accessPointType} ${code}`,
			street: street ?? '-',
			city: city ?? '-',
			zip: zipCode ?? '-',
			country: country ?? '-',
			url: `https://www.ppl.cz/vydejni-mista/${createPplDispatchPointUrl(`${city}-${street}_${id}`)}`,
		})
	}
	return null;
}



function createPplDispatchPointUrl(text: string) {
	return text
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/\//g, '_')
		.replace(/\s+/g, '-')
		.replace(/[^a-z0-9-_]/g, '');
}